// Centralized API base URL for the nested app
export const API_BASE_URL = 'https://api.stocks4u.in';


